/**
 * Calculates the percentage (0-100 whole number) for Meter component
 * @param totalAmount Total balance of the loan / credit line total / etc.
 * @param filledAmount Total amount paid toward the loan / total credit utilized / etc.
 * @returns Percentage filled, as a whole number 0-100. 0 is returned if any param is undefined,
 * or if a divide by 0 would occur (i.e. totalAmount is 0).
 */
var calcMeterPercent = function (totalAmount, filledAmount) {
    if (totalAmount === undefined ||
        filledAmount === undefined ||
        totalAmount === 0) {
        return 0;
    }
    return (filledAmount / totalAmount) * 100;
};
export default calcMeterPercent;
//# sourceMappingURL=calcMeterPercent.js.map